import { render } from "./PaginationPage.vue?vue&type=template&id=ff29fff2"
import script from "./PaginationPage.vue?vue&type=script&lang=js"
export * from "./PaginationPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__